mutation resetPassword($token: String, $password: String, $passwordConfirmation: String, $recaptchaToken: String) {
    resetPassword(token: $token, password: $password, passwordConfirmation: $passwordConfirmation, recaptchaToken: $recaptchaToken)
}
